export const ROUTES = {
  home: () => '/',
  signIn: () => '/sign-in',
  signInTest: () => `${ROUTES.signIn()}-test`,

  orders: () => '/pedidos',

  //picking
  pickingList: () => '/coleta',
  movementPickingList: () => `${ROUTES.pickingList()}/corredor`,
  picking: () => `${ROUTES.pickingList()}/produtos`,
  packing: () => `${ROUTES.picking()}/embalar`,
  resume: () => `${ROUTES.picking()}/resumo`,
  viewResume: () => `${ROUTES.picking()}/resumo/ver`,
  edit: () => `${ROUTES.picking()}/editar`,

  //to
  to: () => `/to`,
  toPickingList: () => `${ROUTES.to()}${ROUTES.pickingList()}`,
  toPicking: () => `${ROUTES.to()}${ROUTES.pickingList()}/produtos`,
  toCheckingList: () => `${ROUTES.to()}/conferencia`,

  //delivery movement
  deliveryMovement: () => '/delivery',
  deliveryMovementPickingList: () =>
    `${ROUTES.deliveryMovement()}${ROUTES.pickingList()}`,
  deliveryMovementPicking: () =>
    `${ROUTES.deliveryMovementPickingList()}/produtos`,
  deliveryMovementOrders: () =>
    `${ROUTES.deliveryMovement()}${ROUTES.orders()}`,

  //checking
  checking: () => `${ROUTES.to()}/conferencia`,
  checkingProduct: () => `${ROUTES.checking()}/produto`,
  checkingResume: () => `${ROUTES.checking()}/resumo`,
  checkingViewResume: () => `${ROUTES.checking()}/ver/resumo`,

  //receive
  receive: () => '/recebimento',
  receiveTasks: () => `${ROUTES.receive()}/tarefas-recebimento`,
  receiveTaskCreate: () => `${ROUTES.receiveTasks()}/criar`,
  receiveTaskEdit: () => `${ROUTES.receiveTasks()}/editar`,
} as const

export const pickingPaths = [
  ROUTES.picking(),
  ROUTES.toPicking(),
  ROUTES.deliveryMovementPicking(),
] as const

export const checkingPaths = [
  ROUTES.checkingProduct(),
  ROUTES.checkingResume(),
  ROUTES.checkingViewResume(),
] as const

export const rootListPaths = [
  ROUTES.orders(),
  ROUTES.pickingList(),
  ROUTES.toPickingList(),
  ROUTES.deliveryMovementPickingList(),
  ROUTES.deliveryMovementOrders(),
  ROUTES.checking(),
  ROUTES.receive(),
  ROUTES.receiveTasks(),
]
